Vendd.Scripts.load(function () {
    'use strict';

    var load = function () {

        var $form = $(".js-edit-address-form");

        if ($form.length < 1) return;

        var form = $form.get(0);

        var $parentWrapper = $(".x-address-list");
        var addressType = $parentWrapper.data('address-type');

        var comboboxWrapperArea = {};
        var comboboxWrapperCountry = {};
        var comboboxWrapperPrefecture = {};
        var comboboxWrapperCity = {};
        var comboboxWrapperAreaAutofill = {};
        var comboboxWrapperTaxAgency = {};
        var comboboxWrapperVatStatus = {};
        var comboboxWrapperAddressGroup = {};
        var getPostCodes = {};
        var getStreets = {};
        var prevCountry, prevPrefecture, prevCity, prevArea, prevPostCode, prevAddress, postCodeChanged = false, fieldsAlreadyValidated = false;

        var model = null, formData, af, countries = [], areas = [], selectedCountry;

        var $html = null;
        var literalsModel = {};

        var validationOptions = {};

        form.update = function () {
            var html = Vendd.Handlebars.parse("accountAddressEditBox_A", model);
            form.initFormData();
            form.bind(html);
        };

        form.bind = function (html) {

            $form.html(html);

            literalsModel = model.Literals;

            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetCountries(model, addressType));
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllAddressGroups(model.GroupId));

            $('.js-required:not(.js-invoice-field)', $form).each(function (e, el) {
                var inputName = $('input, select, textarea', el).attr('name');
                validationOptions[inputName] = {
                    required: inputName + '-required'
                };
            });

            //add phone validation
            if ($('input[name="phone"]', $form).length > 0) {
                validationOptions.phone = validationOptions.phone || {};
                if (venddProjectConfigs.phoneLocalizationEnabled) {
                    _.extend(validationOptions.phone, { isValidPhoneLocalized: { validator: 'phone-invalid', config: { type: 'phone' } } });
                } else {
                    if (venddProjectConfigs.Registration.GreekPhoneValidation) {
                        _.extend(validationOptions.phone, { isGreekPhone: 'phone-invalid' });
                    } else {
                        _.extend(validationOptions.phone, { isPhoneNumber: 'phone-invalid' });
                    }
                }
            }

            //add mobile validation
            if ($('input[name="mobilephone"]', $form).length > 0) {
                validationOptions.mobilephone = validationOptions.mobilephone || {};
                if (venddProjectConfigs.phoneLocalizationEnabled) {
                    _.extend(validationOptions.mobilephone, { isValidPhoneLocalized: { validator: 'mobilephone-invalid', config: { type: 'mobile' } } });
                } else {
                    if (venddProjectConfigs.Registration.GreekMobileValidation) {
                        _.extend(validationOptions.mobilephone, { isGreekMobile: 'mobilephone-invalid' });
                    } else {
                        _.extend(validationOptions.mobilephone, { isPhoneNumber: 'mobilephone-invalid' });
                    }
                }
            }

            $form.validationEngine(validationOptions);
            af = $form.data('validationEngine');

            //check if invoice is enable
            if (model.IsInvoice === false || addressType === "shipping") {
                $('.js-invoiceRelated-wrapper', $form).hide();
            } else {
                form.addInvoiceValidation();
            }

            if (model.IsInvoiceEnabled === false || addressType === "shipping") {
                $('.js-invoiceRelated-container', $form).hide();
            }

            if (venddProjectConfigs.phoneLocalizationEnabled) {
                if ($('input[name="phone"]', $form).length > 0) {
                    $('input[name="phone"]', $form).get(0).addEventListener("countrychange", function () {
                        var $this = $(this);
                        var fieldName = $this.attr('name');

                        formData[fieldName] = $this.val();
                        af.validate(fieldName);
                    });
                }
                if ($('input[name="mobilephone"]', $form).length > 0) {
                    $('input[name="mobilephone"]', $form).get(0).addEventListener("countrychange", function () {
                        var $this = $(this);
                        var fieldName = $this.attr('name');

                        formData[fieldName] = $this.val();
                        af.validate(fieldName);
                    });
                }
            }

            //add postalCode validation only if config parameter is true and selected country has areas
            if (model.Configs.AddressAreaAutoComplete && (selectedCountry && selectedCountry.AreasCount > 1)) {
                form.addPostalCodeValidation();
            }

            //open fancybox
            if (addressType !== 'return') {
                $.fancybox.open($form,
                    {
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        keyboard: false,
                        beforeClose: function (instance, current) {
                            postCodeChanged = false;
                            fieldsAlreadyValidated = false;
                            af.destroy();
                        }
                    }
                );
            }

            $form.show();
        };

        form.initFormData = function () {
            formData = {
                title: model.Title,
                firstName: model.FirstName,
                lastName: model.LastName,
                phone: model.Phones,
                mobilephone: model.Mobiles,
                fax: model.Fax,
                addressLine1: model.AddressLine1,
                addressLine2: model.AddressLine2,
                streetnumber: model.Streetnumber,
                apartment: model.Apartment,
                bell: model.Bell,
                entrance: model.Entrance,
                floor: model.Floor,
                block: model.Block,
                postCode: model.PostCode,
                area: model.Area,
                city: model.City,
                prefecture: model.Prefecture,
                country: model.Country,
                companyName: model.CompanyName,
                headQuarters: model.Headquarters,
                occupation: model.Occupation,
                taxAgency: model.TaxAgency,
                taxAgencyId: model.TaxAgencyId,
                taxIdentifier: model.TaxIdentifier,
                vatStatus: model.VatStatus,
                receiveEinvoice: model.ReceiveEinvoice,
                isInvoice: model.IsInvoice,
                addressGroupId: model.GroupId
            };
        };

        form.resetInvoiceFields = function () {
            formData.taxIdentifier = "";
            formData.taxAgency = "";
            formData.taxAgencyId = null;
            formData.vatStatus = 0;
            formData.companyName = "";
            formData.headQuarters = "";
            formData.occupation = "";
        };

        form.addInvoiceValidation = function () {

            af.addField({ taxIdentifier: { required: 'taxIdentifier-required' } });

            if (model.Configs && model.Configs.IsCompanyNameRequired)
                af.addField({ companyName: { required: 'companyName-required' } });

            if (model.Configs && model.Configs.IsOccupationRequired)
                af.addField({ occupation: { required: 'occupation-required' } });

            if (model.Configs && model.Configs.IsTaxAgencyRequired)
                af.addField({ taxAgency: { required: 'taxAgency-required' } });

            if (model.Configs && model.Configs.IsHeadquartersRequired)
                af.addField({ headQuarters: { required: 'headQuarters-required' } });

            //if country is GR , add validation for greek tax identifier
            if (formData.country === 'GR') form.addTaxIdentifierValidation();
        };

        form.removeInvoiceValidation = function () {

            af.removeField("taxIdentifier");

            if (model.Configs && model.Configs.IsCompanyNameRequired)
                af.removeField("companyName");

            if (model.Configs && model.Configs.IsOccupationRequired)
                af.removeField("occupation");

            if (model.Configs && model.Configs.IsTaxAgencyRequired)
                af.removeField("taxAgency");

            if (model.Configs && model.Configs.IsHeadquartersRequired)
                af.removeField("headQuarters");

            $('input[name = "companyName"], input[name = "occupation"], input[name = "headQuarters"], input[name = "taxAgency"], select[name = "taxAgency"], input[name = "taxIdentifier"]').val("");
        };

        form.addTaxIdentifierValidation = function () {
            af.removeField("taxIdentifier");
            af.addField({ taxIdentifier: { required: 'taxIdentifier-required', isGreekTaxIdentifier: 'taxIdentifier-invalid' } });
            af.validate("taxIdentifier");
        };

        form.removeTaxIdentifierValidation = function () {
            af.removeField("taxIdentifier");
            $('.taxIdentifier-invalid').removeClass('error');

            if (formData.isInvoice) {
                af.addField({ taxIdentifier: { required: 'taxIdentifier-required' } });
            }

            af.validate("taxIdentifier");
        };

        form.addPostalCodeValidation = function () {
            af.removeField("postCode");
            af.addField({ postCode: { required: 'postCode-required', isValidPostalCode: { validator: 'postCode-invalid', config: { country: formData.country, areas: areas } } } });
            af.validate("postCode");
        };

        form.removePostalCodeValidation = function () {
            af.removeField("postCode");
            $('.postCode-invalid').removeClass('error');
            //if has class required
            af.addField({ postCode: { required: 'postCode-required' } });
            af.validate("postCode");
        };

        comboboxWrapperTaxAgency.updateData = function (taxAgencies) {
            //Add Selected parameter in taxAgencies model
            if (model.TaxAgency) {
                if (taxAgencies.Literals) {
                    taxAgencies.TaxAgency = model.TaxAgency;
                } else {
                    _.each(taxAgencies, function (taxAgency, index) {
                        if (taxAgency.Name === model.TaxAgency) {
                            taxAgencies[index].Selected = true;
                            return;
                        }
                    });
                    model.TaxAgency = null;
                }
            }

            var $comboboxWrapperArea = $(".js-tax-agencies-select", $form);
            var taxAgenciesComboboxHtml = Vendd.Handlebars.parse("accountTaxAgencyCombo_A", taxAgencies);
            $comboboxWrapperArea.html(taxAgenciesComboboxHtml);

            if (formData.isInvoice) {

                if (formData.taxIdentifier && formData.country === 'GR') {
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetVatInfo(formData.country, formData.taxIdentifier));
                }

                if (model.Configs && model.Configs.IsTaxAgencyRequired) {
                    //re-init validation after html parse
                    af.removeField("taxAgency");
                    af.addField({ taxAgency: { required: 'taxAgency-required' } });

                    //validate again taxAgency if fields area already validated
                    if (fieldsAlreadyValidated && af.options.taxAgency)
                        af.validateField("taxAgency");
                }
            }
        };

        comboboxWrapperVatStatus.updateData = function (vatStatuses) {
            //Add Selected parameter in VatStatuses model
            _.each(vatStatuses, function (vatStatus, index) {
                if (vatStatus.Id === model.VatStatus) {
                    vatStatuses[index].Selected = true;
                    return;
                }
            });

            var $comboboxWrapperArea = $(".js-vat-status-select", $form);
            var vatStatusComboboxHtml = Vendd.Handlebars.parse("accountVatStatusCombo_A", vatStatuses);
            $comboboxWrapperArea.html(vatStatusComboboxHtml);
        };

        comboboxWrapperCountry.updateData = function (countries) {
            //parse html with new model
            var countriesComboboxHtml = Vendd.Handlebars.parse("accountAddressCountryCombo_A", countries);
            var $comboboxWrapperCountry = $(".js-address-countries-select", $form);
            $comboboxWrapperCountry.html(countriesComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsCountryRequired) {
                af.removeField("country");
                af.addField({ country: { required: 'country-required' } });
            }

            if (formData.country !== '') {
                if (model.Configs && model.Configs.IsTaxAgencyVisible) {
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllTaxAgencies(formData.country));
                }

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllVatStatuses());
            }

            if (formData.country === '' && countries.length === 1) {
                $('select', $comboboxWrapperCountry).val(countries[0].Code);
                formData.country = countries[0].Code;

                if (model.Configs && model.Configs.IsTaxAgencyVisible) {
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllTaxAgencies(formData.country));
                }

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllVatStatuses());

                if (model.Configs && model.Configs.IsPrefectureAutofill) {
                    $('.form-row.prefecture', $form).addClass('x-loading');
                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('prefecture', formData.country));
                }
            }
        };

        comboboxWrapperPrefecture.updateData = function (data) {
            //parse html with new model
            var prefecturesComboboxHtml = Vendd.Handlebars.parse("accountAddressPrefectureCombo_A", data);
            var $comboboxWrapperPrefecture = $(".js-address-prefectures-select", $form);
            $comboboxWrapperPrefecture.html(prefecturesComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsPrefectureRequired) {
                af.removeField("prefecture");
                af.addField({ prefecture: { required: 'prefecture-required' } });
            }

            if (model.Configs && model.Configs.IsPrefectureAutofill) {
                var selectedPrefecture = _.find(data.Prefectures, function (x) { return formData.prefecture === x });

                if (data.Prefectures.length == 1) {
                    $('select', $comboboxWrapperPrefecture).val(data.Prefectures[0]);
                    formData.prefecture = data.Prefectures[0];
                    if (model.Configs && model.Configs.IsCityAutofill) {
                        $('.form-row.city', $form).addClass('x-loading');
                        Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('city', formData.country, formData.prefecture));
                    }
                } else {
                    if (!selectedPrefecture) formData.prefecture = '';
                }
            }

            //validate again prefecture if fields area already validated
            if (fieldsAlreadyValidated && af.options.prefecture) {
                af.validateField('prefecture');
            }
        };

        comboboxWrapperCity.updateData = function (data) {
            //parse html with new model
            var citiesComboboxHtml = Vendd.Handlebars.parse("accountAddressCityCombo_A", data);
            var $comboboxWrapperCity = $(".js-address-cities-select", $form);
            $comboboxWrapperCity.html(citiesComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsCityRequired) {
                af.removeField("city");
                af.addField({ city: { required: 'city-required' } });
            }

            if (model.Configs && model.Configs.IsCityAutofill) {
                var selectedCity = _.find(data.Cities, function (x) { return formData.city === x });

                if (data.Cities.length == 1) {
                    $('select', $comboboxWrapperCity).val(data.Cities[0]);
                    formData.city = data.Cities[0];
                    if (model.Configs && model.Configs.IsAreaAutofill) {
                        $('.form-row.area', $form).addClass('x-loading');
                        Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formData.prefecture, formData.city));
                    }
                } else {
                    if (!selectedCity) formData.city = '';
                }
            }

            //validate again city if fields area already validated
            if (fieldsAlreadyValidated && af.options.city) {
                af.validateField('city');
            }
        };

        comboboxWrapperArea.updateData = function (data) {
            //parse html with new model
            var partial = model.Configs && model.Configs.IsAreaAutofill ? "accountAddressAreaCombo_B" : "accountAddressAreaCombo_A";
            var areasComboboxHtml = Vendd.Handlebars.parse(partial, data);
            var $comboboxWrapperArea = $(".js-address-areas-select", $form);
            $comboboxWrapperArea.html(areasComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsAreaRequired) {
                af.removeField("area");
                af.addField({ area: { required: 'area-required' } });
            }

            if (model.Configs && model.Configs.IsAreaAutofill) {
                var selectedArea = _.find(data.Areas, function (x) { return formData.area === x });

                if (data.Areas.length == 1) {
                    $('select', $comboboxWrapperArea).val(data.Areas[0]);
                    formData.area = data.Areas[0];
                } else {
                    if (!selectedArea) formData.area = '';
                }
            }

            //validate again area if fields area already validated
            if (fieldsAlreadyValidated && af.options.area) {
                af.validateField('area');
            }

            //validate postal code
            if (model.Configs.AddressAreaAutoComplete && (selectedCountry && selectedCountry.AreasCount > 1)) {
                form.addPostalCodeValidation();
            } else {
                form.removePostalCodeValidation();
            }

        };

        comboboxWrapperAddressGroup.updateData = function (addressGroups) {
            // Update 'Selected' attribute in addressGroups model
            if (model.GroupId > 0) {
                _.each(addressGroups.Items, function (addressGroup, index) {
                    addressGroup.Selected = (addressGroup.Value.Id === model.GroupId);
                });
            }

            var $comboboxWrapperAddressGroups = $(".js-address-group-select", $form);
            var addressGroupsComboboxHtml = Vendd.Handlebars.parse("accountAddressGroupCombo_A", addressGroups);
            $comboboxWrapperAddressGroups.html(addressGroupsComboboxHtml);

            //re-init validation after html parse
            if (model.Configs && model.Configs.IsAddressGroupRequired) {
                af.removeField('addressGroup');
                af.addField({ addressGroup: { required: 'addressGroup-required' } });
            }

            //validate again addressGroup if fields area already validated
            if (fieldsAlreadyValidated && af.options.addressGroup) {
                af.validateField('addressGroup');
            }
        };

        getPostCodes = function (postcode) {
            var run = false;
            if (model.Configs && formData.country) {
                if (model.Configs.IsPrefectureAutofill) {
                    if (formData.prefecture) {
                        if (model.Configs.IsCityAutofill) {
                            if (formData.city) {
                                if (model.Configs.IsAreaAutofill) {
                                    if (formData.area) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else {
                            run = true;
                        }
                    }
                } else if (model.Configs.IsCityAutofill) {
                    if (formData.city) {
                        if (model.Configs.IsAreaAutofill) {
                            if (formData.area) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }
                } else if (model.Configs.IsAreaAutofill) {
                    if (formData.area) {
                        run = true;
                    }
                } else {
                    run = true;
                }
            }

            if (run) {
                var searchText = $('.js-postal-code-autofill').val();
                if (prevCountry != formData.country || prevPrefecture != formData.prefecture || prevCity != formData.city || prevArea != formData.area || prevPostCode != searchText) {
                    prevCountry = formData.country;
                    prevPrefecture = formData.prefecture;
                    prevCity = formData.city;
                    prevArea = formData.area;
                    prevPostCode = searchText;

                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('postalCode', formData.country, formData.prefecture, formData.city, formData.area, '*' + searchText + '*'));
                } else {
                    if ($('.postCode-list').length > 0 && $('.postCode-list').hasClass('hidden'))
                        $('.postCode-list').removeClass('hidden');
                }
            }
        };

        getStreets = function (street) {
            var run = false;
            if (model.Configs && formData.country) {
                if (model.Configs.IsPrefectureAutofill) {
                    if (formData.prefecture) {
                        if (model.Configs.IsCityAutofill) {
                            if (formData.city) {
                                if (model.Configs.IsAreaAutofill) {
                                    if (formData.area) {
                                        run = true;
                                    }
                                } else {
                                    run = true;
                                }
                            }
                        } else {
                            run = true;
                        }
                    }
                } else if (model.Configs.IsCityAutofill) {
                    if (formData.city) {
                        if (model.Configs.IsAreaAutofill) {
                            if (formData.area) {
                                run = true;
                            }
                        } else {
                            run = true;
                        }
                    }
                } else if (model.Configs.IsAreaAutofill) {
                    if (formData.area) {
                        run = true;
                    }
                } else {
                    run = true;
                }
            }

            if (run) {
                var searchText = $('.js-address-autofill').val();
                if (prevCountry != formData.country || prevPrefecture != formData.prefecture || prevCity != formData.city || prevArea != formData.area || prevAddress != searchText) {
                    prevCountry = formData.country;
                    prevPrefecture = formData.prefecture;
                    prevCity = formData.city;
                    prevArea = formData.area;
                    prevAddress = searchText;

                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('street', formData.country, formData.prefecture, formData.city, formData.area, '', '*' + searchText + '*'));
                } else {
                    if ($('.address-list').length > 0 && $('.address-list').hasClass('hidden'))
                        $('.address-list').removeClass('hidden');
                }
            }
        };

        $form.on('keyup', 'input[name]', function (e) {

            var $this = $(this);
            var fieldName = $this.attr('name');

            formData[fieldName] = $this.val();
            af.validate(fieldName);
        });

        $form.on('change', 'select[name]', function (e) {

            var $this = $(this);
            var fieldName = $this.attr('name');

            formData[fieldName] = $this.val();
            af.validate(fieldName);
        });

        $form.on('change', '.js-invoice-address-checkbox', function () {
            if (this.checked) {
                formData.isInvoice = true;
                $('.js-invoiceRelated-wrapper', $form).show();
            } else {
                formData.isInvoice = false;
                $('.js-invoiceRelated-wrapper', $form).hide();
            }
        });

        $form.on('keyup', 'input[name = "taxIdentifier"]', $.debounce(400, function () {

            if (!model.Configs.InvoiceAutoComplete || formData.taxIdentifier == null || formData.taxIdentifier == '' || formData.country !== 'GR')
                return;

            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetVatInfo(formData.country, formData.taxIdentifier));
        }));

        $form.on('click', '.js-submit-button', function (id) {

            if (formData.isInvoice) {
                form.addInvoiceValidation();
            } else {
                form.removeInvoiceValidation();
                form.removeTaxIdentifierValidation();
            }

            var val1 = af.validate();

            if (val1) {

                $('input[name]:not([type="checkbox"]):not([type="radio"]), select[name]', $form).each(function () {
                    formData[$(this).attr('name')] = $(this).val();
                });

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.CheckAddressIfExists(
                    model.Id,
                    formData.firstName,
                    formData.lastName,
                    formData.addressLine1,
                    formData.addressLine2,
                    formData.city,
                    formData.postCode,
                    formData.country,
                    formData.area,
                    model.IsBilling,
                    model.IsShipping
                ));
            }

            fieldsAlreadyValidated = true;
        });

        $form.on('change', '.js-countries-selector', function (id) {

            var emptyModelCity = {}, emptyModelArea = {};

            selectedCountry = _.first(_.filter(countries, { Code: formData.country }));

            if (model.Configs && model.Configs.IsPrefectureAutofill) {
                $('.form-row.prefecture', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('prefecture', formData.country));

                emptyModelCity.Literals = literalsModel;
                emptyModelCity.Cities = [];

                emptyModelArea.Literals = literalsModel;
                emptyModelArea.Areas = [];

                comboboxWrapperCity.updateData(emptyModelCity);
                comboboxWrapperArea.updateData(emptyModelArea);

            } else if (model.Configs && model.Configs.IsCityAutofill) {
                $('.form-row.city', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('city', formData.country, formData.prefecture));

                emptyModelArea.Literals = literalsModel;
                emptyModelArea.Areas = [];

                comboboxWrapperArea.updateData(emptyModelArea);

            } else if (model.Configs && model.Configs.IsAreaAutofill) {
                $('.form-row.area', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formData.prefecture, formData.city));

            } else {
                //reset prefecture
                $('input[name=prefecture]').val('');
                //reset city
                $('input[name=city]').val('');
                //reset postal code
                $('.js-postal-code').val('');
                //reset area
                emptyModelArea.Literals = literalsModel;
                comboboxWrapperArea.updateData(emptyModelArea);
            }

            //if invoice is checked
            if (formData.isInvoice) {
                //if country is GR add validation else remove validation
                if (formData.country === 'GR') {
                    form.addTaxIdentifierValidation();
                } else {
                    form.removeTaxIdentifierValidation();
                }
            }

            if (model.Configs && model.Configs.IsTaxAgencyVisible) {
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllTaxAgencies(formData.country));
            }

            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAllVatStatuses());

        });

        $form.on('change', '.js-prefectures-selector', function (id) {
            if (model.Configs && model.Configs.IsCityAutofill) {
                $('.form-row.city', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('city', formData.country, formData.prefecture));

                var emptyModelArea = {};
                emptyModelArea.Literals = literalsModel;
                emptyModelArea.Areas = [];

                comboboxWrapperArea.updateData(emptyModelArea);

            } else if (model.Configs && model.Configs.IsAreaAutofill) {
                $('.form-row.area', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formData.prefecture, formData.city));

            }
        });

        $form.on('change', '.js-cities-selector', function (id) {
            if (model.Configs && model.Configs.IsAreaAutofill) {
                $('.form-row.area', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formData.prefecture, formData.city));
            }
        });

        $form.on('keyup', '.js-postal-code', $.debounce(500, function (postcode) {
            if (model.Configs && !model.Configs.IsAreaAutofill) {
                postCodeChanged = true;
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAreasForPostCode(formData.country, formData.postCode, formData.area));
            }
        }));

        $form.on('keyup', '.js-postal-code-autofill', $.debounce(1000, function (postcode) {
            getPostCodes(postcode);
        }));

        $form.on('focus', '.js-postal-code-autofill', function (postcode) {
            getPostCodes(postcode);
        });

        $form.on('keyup', '.js-address-autofill', $.debounce(1000, function (street) {
            getStreets(street);
        }));

        $form.on('focus', '.js-address-autofill', function (street) {
            getStreets(street);
        });

        $form.on('click', '.postCode-item', function () {
            var postCode = $(this).data('value');
            formData.postCode = postCode;
            $('.js-postal-code-autofill').val(postCode);
            $('.postCode-list').addClass('hidden');
        });

        $form.on('click', '.address-item', function () {
            var address = $(this).data('value');
            formData.addressLine1 = address;
            $('.js-address-autofill').val(address);
            $('.address-list').addClass('hidden');
        });

        $form.on('change', '.js-tax-agencies', function (id) {
            model.TaxAgencyId = $('.tax-agencies-select.js-tax-agencies-select select option:selected').data("id");
        });

        $form.on('change', '.js-address-group', function (id) {
            model.GroupId = $('.address-group-select.js-address-group-select select option:selected').data("id");
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.OpenAddressEditForm, form, function (envelope) {
            model = envelope.message.data.model;
            form.update();

            if (venddProjectConfigs.phoneLocalizationEnabled) {
                //call public function for phone localization
                initPhoneLocalization();
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditAddressSuccess, form, function (envelope) {
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.AddressModelChanged());
            $form.hide();
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetCountriesSuccess, form, function (envelope) {
            countries = envelope.message.data.model;

            selectedCountry = countries.length > 1 ? _.first(_.filter(countries, { Code: formData.country })) : countries[0];
            countries[0].Selected = selectedCountry ? true : false;

            //Fill Countries Combobox
            comboboxWrapperCountry.updateData(countries);

            var runGetPrefectures = false, runGetCities = false, runGetAreas = false;

            if (formData.country !== '' && model.Configs && model.Configs.IsPrefectureAutofill) {
                runGetPrefectures = true;
            }

            if (formData.country !== '' && model.Configs && model.Configs.IsCityAutofill) {
                if (model.Configs.IsPrefectureAutofill) {
                    if (formData.prefecture !== '') {
                        runGetCities = true;
                    }
                } else {
                    runGetCities = true;
                }
            }

            if (formData.country !== '' && model.Configs && model.Configs.IsAreaAutofill) {
                if (model.Configs.IsPrefectureAutofill) {
                    if (formData.prefecture !== '') {
                        if (model.Configs.IsCityAutofill) {
                            if (formData.city !== '') {
                                runGetAreas = true;
                            }
                        } else {
                            runGetAreas = true;
                        }
                    }
                } else if (model.Configs.IsCityAutofill) {
                    if (formData.city !== '') {
                        runGetAreas = true;
                    }
                } else {
                    runGetAreas = true;
                }
            }

            if (runGetPrefectures) {
                $('.form-row.prefecture', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('prefecture', formData.country));
            }

            if (runGetCities) {
                $('.form-row.city', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('city', formData.country, formDara.prefecture));
            }

            if (runGetAreas) {
                $('.form-row.area', $form).addClass('x-loading');
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAddressInfo('geoArea', formData.country, formDara.prefecture, formData.city));
            }

            if (model.Configs && !model.Configs.IsCountryAutofill && !model.Configs.IsAreaAutofill && formData.postCode !== '' && formData.postCode !== undefined && (selectedCountry && selectedCountry.AreasCount > 1)) {
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.GetAreasForPostCode(formData.country, formData.postCode, formData.area));
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddressInfoSuccess, form, function (envelope) {
            var model = envelope.message.data.model;
            var fields = model.arguments.fields;
            var addressData = model.data;

            var data = {};
            data.Literals = literalsModel;

            //update fields
            if (fields.length <= 1) {
                if (fields[0] === "prefecture") {
                    data.Prefectures = _.map(addressData, function (obj) { return obj.prefecture; });
                    comboboxWrapperPrefecture.updateData(data);
                    $('.form-row.prefecture', $form).removeClass('x-loading');

                } else if (fields[0] === "city") {
                    data.Cities = _.map(addressData, function (obj) { return obj.city; });
                    comboboxWrapperCity.updateData(data);
                    $('.form-row.city', $form).removeClass('x-loading');

                } else if (fields[0] === "geoArea") {
                    data.Areas = _.map(addressData, function (obj) { return obj.geoArea; });
                    comboboxWrapperArea.updateData(data);
                    $('.form-row.area', $form).removeClass('x-loading');

                } else if (fields[0] === "street") {
                    data.Streets = _.map(addressData, function (obj) { return obj.street; });

                    if ($('ul.address-list').length > 0)
                        $('ul.address-list').remove();

                    if (data.Streets.length > 0) {
                        var streetList = $('<ul/>').addClass('generated-list address-list');

                        $.each(data.Streets, function (i, value) {
                            var li = $('<li/>').addClass('address-item').attr('data-value', value).text(value);
                            li.appendTo(streetList);
                        });

                        streetList.insertAfter('.address1 .input-wrapper');
                    }
                } else if (fields[0] === "postalCode") {
                    data.PostCodes = _.map(addressData, function (obj) { return obj.postalCode; });

                    if ($('ul.postCode-list').length > 0)
                        $('ul.postCode-list').remove();

                    if (data.PostCodes.length > 0) {
                        var postCodeList = $('<ul/>').addClass('generated-list postCode-list');

                        $.each(data.PostCodes, function (i, value) {
                            var li = $('<li/>').addClass('postCode-item').attr('data-value', value).text(value);
                            li.appendTo(postCodeList);
                        });

                        postCodeList.insertAfter('.postCode .input-wrapper');
                    }
                }
            }

        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAreasForPostCodeSuccess, form, function (envelope) {
            areas = envelope.message.data.model;

            if (areas.length == 1) {
                formData.area = areas[0].Name;
            }

            if (areas.length > 0) {
                var city = areas[0].City;
                if (city !== "") {
                    if (postCodeChanged || (!postCodeChanged && $(".form-row.city input", $form).val() == "")) {
                        formData.city = city;
                        $(".form-row.city input", $form).val(city);

                        //validate again city if fields area already validated
                        if (fieldsAlreadyValidated && af.options.city) {
                            af.validateField('city');
                        }
                    }
                }
                
                postCodeChanged = false;
            }

            if (areas.length > 0) {
                comboboxWrapperArea.updateData(areas);
            } else {
                var data = {};
                data.Literals = literalsModel;
                comboboxWrapperArea.updateData(data);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllTaxAgenciesSuccess, form, function (envelope) {
            if (envelope.message.data.model.length > 0) {
                comboboxWrapperTaxAgency.updateData(envelope.message.data.model);
            } else {
                var data = {};
                data.Literals = literalsModel;
                comboboxWrapperTaxAgency.updateData(data);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllVatStatusesSuccess, form, function (envelope) {
            if (envelope.message.data.model.length > 0) {
                comboboxWrapperVatStatus.updateData(envelope.message.data.model);
            } else {
                var data = {};
                data.Literals = literalsModel;
                comboboxWrapperVatStatus.updateData(data);
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetVatInfoSuccess, form, function (envelope) {
            var data = envelope.message.data.model;

            if (data.isValid) {
                if (data.name !== formData.companyName && data.name !== null && data.name !== "") {
                    $('input[name = "companyName"]:text').val(data.name);
                    formData.companyName = data.name;
                    af.validate("companyName");
                }
                if (data.occupation !== formData.occupation && data.occupation !== null && data.occupation !== "") {
                    $('input[name = "occupation"]:text').val(data.occupation);
                    formData.occupation = data.occupation;
                    af.validate("occupation");
                }
                if (data.taxAgency !== formData.taxAgency && data.taxAgency !== null && data.taxAgency !== "") {
                    if ($('select[name="taxAgency"]').length > 0) {
                        $('select[name="taxAgency"] option[data-code=' + data.taxAgencyCode + ']').prop('selected', true);
                        formData.taxAgency = $('select[name="taxAgency"]').val();
                    } else {
                        $('input[name="taxAgency"]').val(data.taxAgency);
                        formData.taxAgency = data.taxAgency;
                    }
                }
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAllAddressGroupsSuccess, form, function (envelope) {
            comboboxWrapperAddressGroup.updateData(envelope.message.data.model);
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressIfExistsSuccess, form, function (envelope) {

            if (envelope.message.data.success === false) {
                $('.address-already-exists', $form).show();

            } else {
                $.fancybox.close();
                var check = true;
                try {
                    var addressMatched = JSON.parse(envelope.message.data.data);
                    if (addressMatched.AddressId == -1) check = false;
                } catch (ex) {
                    /* failed to parse json */
                }

                if (check) {

                    //reset invoice fields
                    if (addressType === "shipping" || formData.isInvoice === false) form.resetInvoiceFields();

                    Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.EditAddress(
                        addressType,
                        model.Id,
                        formData.title,
                        formData.firstName,
                        formData.lastName,
                        formData.phone,
                        formData.mobilephone,
                        formData.fax,
                        formData.addressLine1,
                        formData.addressLine2,
                        formData.streetnumber,
                        formData.apartment,
                        formData.bell,
                        formData.entrance,
                        formData.floor,
                        formData.block,
                        formData.postCode,
                        formData.area,
                        formData.city,
                        formData.prefecture,
                        formData.country,
                        formData.companyName,
                        formData.headQuarters,
                        formData.occupation,
                        formData.taxAgency,
                        formData.taxAgencyId,
                        formData.taxIdentifier,
                        formData.vatStatus,
                        formData.receiveEinvoice,
                        formData.isInvoice,
                        formData.addressGroupId
                    ));
                }
            }

        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressIfExistsFailure, form, function (envelope) { });

        /* messages referring to requestReturnContactValidationForm_A.js - start */
        Vendd.MessageBus.subscribe(Vendd.Account.Messages.ValidateEditControl, form, function (envelope) {
            var val = af.validate();

            if (val) {
                $('input[name]:not([type="checkbox"]):not([type="radio"]), select[name]', $form).each(function () {
                    formData[$(this).attr('name')] = $(this).val();
                });

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.ValidateEditControlSuccess(val, formData));
            } else {
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.ValidateEditControlSuccess(val));
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.ResetEditControl, form, function (envelope) {
            af.destroy();
        });
        /* messages referring to requestReturnContactValidationForm_A.js - end */
    };

    // messages referring to requestReturnContactValidationForm_A.js
    Vendd.MessageBus.subscribe(Vendd.Account.Messages.ReloadEditControl, "accountAddressEditForm", function (envelope) {
        //load again control
        load();

        Vendd.MessageBus.publishAsync("accountAddressEditForm", new Vendd.Account.Messages.ReloadEditControlSuccess());
    });

    load();

});
